import { CustomInline } from './custom_inline'
import { PhoneCallInline } from './phone_call_inline'
import { PhysicalInline } from './physical_inline'
import { ReadonlyCustomInline } from './readonly_fields/custom_field'
import { ReadonlyPhoneCallInline } from './readonly_fields/phone_call'
import { ReadonlyPhysicalInline } from './readonly_fields/physical_field'

const INLINE_FOR_KIND = {
  custom: CustomInline,
  physical: PhysicalInline,
  outbound_call: PhoneCallInline,
  inbound_call: PhoneCallInline,
}

const READONLY_INLINE_FOR_KIND = {
  custom: ReadonlyCustomInline,
  physical: ReadonlyPhysicalInline,
  outbound_call: ReadonlyPhoneCallInline,
  inbound_call: ReadonlyPhoneCallInline
}
export const InlineChooser = ({ kind, isReadOnly, ...rest }) => {
  const Inline = isReadOnly ? READONLY_INLINE_FOR_KIND[kind] : INLINE_FOR_KIND[kind]
  if (!Inline) return null

  return (
    <Inline
      kind={kind}
      {...rest}
    />
  )
}
